import {
  HTTP_GETBUDGETCOMPDBYDEPT_FETCHING,
  HTTP_GETBUDGETCOMPDBYDEPT_SUCCESS,
  HTTP_GETBUDGETCOMPDBYDEPT_FAILED,
  HTTP_RESET_GETBUDGETCOMPDBYDEPT,
} from "src/Constants";

const initialState = {
  result: [],
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_GETBUDGETCOMPDBYDEPT_FETCHING:
      return {
        ...state,
        result: [],
        isFetching: true,
        isError: false,
      };
    case HTTP_GETBUDGETCOMPDBYDEPT_SUCCESS:
      return {
        ...state,
        result: payload,
        isFetching: false,
        isError: false,
      };
    case HTTP_GETBUDGETCOMPDBYDEPT_FAILED:
      return {
        ...state,
        result: [],
        isFetching: false,
        isError: true,
      };
    default:
      return state;
  }
};
